import { ReactNode } from "react";

interface TextProps {
  type: "h1" | "title" | "subtitle" | "main";
  children: ReactNode;
  className?: string;
}

function Text({ type, children, className }: TextProps) {
  switch (type) {
    case "h1":
      return (
        <p className={`sm:text-h1 text-h1-mobile ${className}`}>{children}</p>
      );
    case "title":
      return (
        <p className={`sm:text-title text-title-mobile font-medium ${className}`}>
          {children}
        </p>
      );
    case "subtitle":
      return (
        <p
          className={`sm:text-subtitle text-subtitle-mobile leading-[100%] font-medium ${className}`}
        >
          {children}
        </p>
      );
    case "main":
      return (
        <p className={`sm:text-main text-main-mobile tracking-[0.2px] leading-[120%] ${className}`}>
          {children}
        </p>
      );
  }
}

export { Text };
